var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 579.37 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#213d81;}.cls-2{fill:#29a3de;}.cls-3{fill:#e3e4e4;}.cls-4{fill:#75c9f2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.45,73.5l-3.13-7.89H126.69l-3.2,7.9a2,2,0,0,1-1.85,1.25H110.06a2,2,0,0,1-1.82-2.82l23-51.21A2,2,0,0,1,133,19.55h13.18A2,2,0,0,1,148,20.74L170.87,72A2,2,0,0,1,169,74.76H157.31A2,2,0,0,1,155.45,73.5ZM147.2,53l-7.65-19.4L131.74,53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.59,19.55h10.9a2,2,0,0,1,2,2V72.76a2,2,0,0,1-2,2h-10.3a2,2,0,0,1-1.62-.83L191.76,43.68,192.08,57V72.76a2,2,0,0,1-2,2H179.17a2,2,0,0,1-2-2V21.55a2,2,0,0,1,2-2h10.31a2,2,0,0,1,1.62.83l21.8,30.4-.31-13.48V21.55A2,2,0,0,1,214.59,19.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281,73.5l-3.13-7.89H252.26l-3.2,7.9a2,2,0,0,1-1.85,1.25H235.63a2,2,0,0,1-1.82-2.82l23-51.21a2,2,0,0,1,1.83-1.18h13.18a2,2,0,0,1,1.82,1.19L296.44,72a2,2,0,0,1-1.83,2.81H282.88A2,2,0,0,1,281,73.5ZM272.77,53l-7.65-19.4L257.31,53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.75,72.76V21.55a2,2,0,0,1,2-2h11a2,2,0,0,1,2,2V61.43h25a2,2,0,0,1,2,2v9.33a2,2,0,0,1-2,2h-38A2,2,0,0,1,302.75,72.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M394.7,22.66,374.29,53.39V72.76a2,2,0,0,1-2,2h-11a2,2,0,0,1-2-2V53.46L339.58,22.63a2,2,0,0,1,1.68-3.08h12.65a2,2,0,0,1,1.71,1L367,39.5l11.56-19a2,2,0,0,1,1.71-1H393A2,2,0,0,1,394.7,22.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M445,21.55v8.78a2,2,0,0,1-2,2H428.71V72.76a2,2,0,0,1-2,2h-11a2,2,0,0,1-2-2V32.33H399.48a2,2,0,0,1-2-2V21.55a2,2,0,0,1,2-2H443A2,2,0,0,1,445,21.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M452.38,72.76V21.55a2,2,0,0,1,2-2h11a2,2,0,0,1,2,2V72.76a2,2,0,0,1-2,2h-11A2,2,0,0,1,452.38,72.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M484.32,68.14c-5.44-5.29-8.2-12.31-8.2-21s2.76-15.78,8.28-21.06,12.7-7.89,21.53-7.89a29.09,29.09,0,0,1,19.64,7.23,2,2,0,0,1,.13,2.93l-6.24,6.41a2,2,0,0,1-2.67.17,16.71,16.71,0,0,0-10.54-3.57,14.44,14.44,0,0,0-11,4.34,15.94,15.94,0,0,0-4.18,11.44,15.93,15.93,0,0,0,4.18,11.43,14.44,14.44,0,0,0,11,4.34,18.53,18.53,0,0,0,11.93-4.08,2,2,0,0,1,2.79.24l5.85,6.78a2,2,0,0,1-.23,2.84,30.23,30.23,0,0,1-20.34,7.39C497,76.1,489.76,73.42,484.32,68.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M532.62,66.72l5.45-7.56a2,2,0,0,1,2.71-.49A26.41,26.41,0,0,0,555.55,63c5.67,0,9.15-1.89,9.15-5s-2.84-4.65-9.71-5.29c-15.14-1.34-21.92-6.62-21.92-16.8A15.45,15.45,0,0,1,539.46,23c4.26-3.23,9.93-4.89,16.95-4.89q11.21,0,19.32,4.94a2,2,0,0,1,.64,2.82l-4.69,7.16a2,2,0,0,1-2.68.63,23,23,0,0,0-11.8-3.09c-6,0-9.62,1.82-9.62,4.73,0,3.08,2.52,4.34,9.54,5,14.52,1.5,22.25,7.65,22.25,17.83a15.64,15.64,0,0,1-6.55,13c-4.42,3.31-10.18,5-17.19,5-8.45,0-16.69-2.44-22.56-6.66A2,2,0,0,1,532.62,66.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 28.55,
    y: 2.5,
    width: 16.17,
    height: 78,
    rx: 8.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.63,83A10.6,10.6,0,0,1,26.05,72.42V10.58a10.59,10.59,0,0,1,21.17,0V72.42A10.6,10.6,0,0,1,36.63,83Zm0-78a5.6,5.6,0,0,0-5.58,5.58V72.42a5.59,5.59,0,0,0,11.17,0V10.58A5.6,5.6,0,0,0,36.63,5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2.5,
    y: 45.37,
    width: 16.17,
    height: 35.14,
    rx: 8.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.58,83A10.6,10.6,0,0,1,0,72.42v-19a10.59,10.59,0,0,1,21.17,0v19A10.6,10.6,0,0,1,10.58,83Zm0-35.13A5.59,5.59,0,0,0,5,53.45v19a5.59,5.59,0,0,0,11.17,0v-19A5.58,5.58,0,0,0,10.58,47.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 54.6,
    y: 22,
    width: 16.17,
    height: 58.5,
    rx: 8.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.68,83A10.6,10.6,0,0,1,52.1,72.42V30.09a10.59,10.59,0,1,1,21.17,0V72.42A10.6,10.6,0,0,1,62.68,83Zm0-58.5a5.6,5.6,0,0,0-5.58,5.59V72.42a5.59,5.59,0,0,0,11.17,0V30.09A5.6,5.6,0,0,0,62.68,24.5Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9ab06de14f3ba840a7c8f5cf360681e0.svg";
export { ForwardRef as ReactComponent };